import React from 'react';
import Login from "../../Screens/Login/Login.screen";

const AuthGuard = ({isAuthenticated, children}) => {
    return isAuthenticated ? children : <Login />
};

export default AuthGuard;